import { render, staticRenderFns } from "./SubsClaimAdmin.vue?vue&type=template&id=16a379f8&scoped=true"
import script from "./SubsClaimAdmin.vue?vue&type=script&lang=js"
export * from "./SubsClaimAdmin.vue?vue&type=script&lang=js"
import style0 from "./SubsClaimAdmin.vue?vue&type=style&index=0&id=16a379f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a379f8",
  null
  
)

export default component.exports